import { Avatar, Badge, Flex, theme } from 'antd';
import React from 'react';

export default function MeetingChatCard({ chat, userId, isSelected, isHovered, onSelect, onMouseEnter, onMouseLeave }) {
  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
      colorPrimary,
      colorPrimaryBorder,
      colorTextDescription,
      colorPrimaryBgHover,
      colorPrimaryBg,
      fontSizeSM,
    },
  } = theme.useToken();

  const nameCardContainerStyle = {
    marginTop: 8,
    padding: '8px 4px',
    borderRadius: borderRadiusLG,
    cursor: 'pointer',
    backgroundColor: isSelected
      ? colorPrimaryBgHover
      : isHovered
      ? colorPrimaryBg
      : colorBgContainer,
    transition: 'background-color 0.3s',
  };

  const avatarStyle = {
    backgroundColor: colorPrimaryBorder,
    color: colorPrimary,
    height: 40,
    width: 48,
  };

  const chatSummeryStyle = {
    fontSize: fontSizeSM,
    color: colorTextDescription,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '230px',
    display: 'inline-block',
  };

  const chatUserStyle = {
    display: 'inline-block',
    maxWidth: 200,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  const displayName = chat?.name;
  if (!displayName) return null;

  return (
    <Flex
      align="center"
      justify="flex-start"
      gap={8}
      style={nameCardContainerStyle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={() => onSelect(chat.id, chat)}
    >
      <Avatar style={avatarStyle}>
        {displayName.charAt(0)}
      </Avatar>
      <Flex align="" vertical={true} style={{ width: '100%' }}>
        <Flex align="center" justify="space-between">
          <span style={chatUserStyle}>{displayName}</span>
          <span style={{ fontSize: fontSizeSM, color: colorTextDescription }}>
            {chat.updatedAt ? new Date(chat.updatedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
          </span>
        </Flex>
        <Flex align="center" justify="space-between">
          <span style={chatSummeryStyle}>
            {chat.messages && chat.messages.length > 0 
              ? chat.messages[chat.messages.length - 1]?.text 
              : "No message available"}
          </span>
          {chat?.unreadCount > 0 && (
            <Badge size="small" overflowCount={10} count={chat?.unreadCount} color={colorPrimary} />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
}

